module.exports = __webpack_public_path__ + "static/media/94efcc5626019bed5b07ae8a4ed4cd6bada7b8e4-24x24.54843bf3.png";